type FabKebabProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabKebab = ({className, size = 26, fill = 'currentColor'}: FabKebabProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 26 26"
        fill={fill}
        className={className}
        aria-hidden
    >
        <circle cx="4" cy="13" r="2" />
        <circle cx="10" cy="13" r="2" />
        <circle cx="16" cy="13" r="2" />
        <circle cx="22" cy="13" r="2" />
    </svg>
);

export default FabKebab;
